module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8XYuc"))).then(() => parcelRequire('5erN3'));